import { z } from 'zod';

/**
 * Пейринг-вход мобилки: приложение получает пару значений, открывает бота,
 * бот подтверждает, приложение забирает токены опросом.
 *
 * Значений два намеренно: `requestId` едет в deep-link (а значит — через
 * серверы Telegram и лог бота), `pollSecret` не покидает память приложения.
 */

/** Клиентская платформа — показывается человеку в сообщении бота. */
export const PairPlatform = z.enum(['ios', 'android']);
export type PairPlatform = z.infer<typeof PairPlatform>;

export const TelegramPairStartInput = z.object({
  platform: PairPlatform,
});
export type TelegramPairStartInput = z.infer<typeof TelegramPairStartInput>;

export const TelegramPairStartResponse = z.object({
  /** 16 hex — публичный идентификатор запроса, сам по себе ничего не открывает. */
  requestId: z.string().regex(/^[a-f0-9]{16}$/),
  /** 64 hex — предъявляется при опросе; в Redis лежит только его SHA-256. */
  pollSecret: z.string().regex(/^[a-f0-9]{64}$/),
  deepLink: z.url(),
  expiresAt: z.iso.datetime(),
});
export type TelegramPairStartResponse = z.infer<typeof TelegramPairStartResponse>;

export const TelegramPairPollInput = z.object({
  requestId: z.string().regex(/^[a-f0-9]{16}$/),
  pollSecret: z.string().regex(/^[a-f0-9]{64}$/),
});
export type TelegramPairPollInput = z.infer<typeof TelegramPairPollInput>;

/**
 * `claimed` присутствует всегда (у входа — `false`), чтобы клиент не различал
 * две формы ответа: ветка «вход или привязка» решается на сервере.
 */
export const TelegramPairPollResponse = z.discriminatedUnion('status', [
  z.object({ status: z.literal('pending') }),
  z.object({ status: z.literal('expired') }),
  z.object({
    status: z.literal('ok'),
    accessToken: z.string(),
    refreshToken: z.string(),
    claimed: z.boolean(),
  }),
]);
export type TelegramPairPollResponse = z.infer<typeof TelegramPairPollResponse>;
